import { render, staticRenderFns } from "./SkillsAndToolsPage.vue?vue&type=template&id=72a4f2c5&scoped=true"
import script from "./SkillsAndToolsPage.vue?vue&type=script&lang=js"
export * from "./SkillsAndToolsPage.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=72a4f2c5&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a4f2c5",
  null
  
)

export default component.exports